import { useForm } from "react-hook-form";
import { GetProfile } from "../../../services/panel/profile/getProfile";
import useGetData from "../../../hook/getData";
import { useEffect } from "react";
import { GetOrders } from "../../../services/panel/orders/getOrders";
import { splitNumber } from "../../../features/splitNumber/splitNumber";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Link } from "react-router";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);


const Profile = () => {
    const { reset } = useForm();
    const { data: profile } = useGetData(['profile'], GetProfile)
    const { data: orders } = useGetData(['orders'], GetOrders)
    useEffect(() => {
        if (profile) {
            reset({
                name: profile?.name || '',
                lastName: profile?.lastName || '',
                email: profile?.email || '',
            });
            localStorage.setItem("cellphone", profile?.cellphone ?? 'خالی');
            localStorage.setItem("username", profile?.name + ' ' + profile?.lastName);
            profile?.image != null ? localStorage.setItem("image", profile?.image) : localStorage.removeItem('image');
            localStorage.setItem('name', profile?.name ?? 'خالی');
            localStorage.setItem('lastName', profile?.lastName ?? 'خالی');
            localStorage.setItem('email', profile?.email ?? 'خالی');
            localStorage.setItem('nationalCode', profile?.national_code ?? 'خالی');
            localStorage.setItem('gender', profile?.gender === 'male' ? 'مرد' : profile?.gender == 'female' ? 'خانوم' : 'خالی');
            const hasRefreshed = localStorage.getItem("profile_page_refreshed");
            if (!hasRefreshed) {
                localStorage.setItem("profile_page_refreshed", "true");
                window.location.reload();
            }
        }

    }, [profile, profile?.cellphone, profile?.email, profile?.image, profile?.lastName, profile?.name, reset])
    return (
        <>
            <div className="card card-body shadow border-1 rounded rounded-4">
                <div className="d-flex align-items-center justify-content-between">
                    <h6 className="fw-bold mb-0">اطلاعات کاربر</h6>
                    <Link to={'/user/detail'} type="submit" className="btn btn-primary">
                        ویرایش اطلاعات
                    </Link>
                </div>
                <hr />
                <div className="row justify-content-center gy-3">
                    <div className="col-md-2 text-md-start text-center">
                        <img className="rounded-circle" style={{ width: '80px', height: '80px', }} alt="category" src={localStorage.getItem('image') ? localStorage.getItem('image') : require('./../../../assets/media/logo/final.png')} />
                    </div>
                    <div className="col-md-10">
                        <div className="row gy-3 font-medium">
                            <div className="col-md-3 col-6">
                                <p className="h6 text-muted font-medium-lg">نام</p>
                                <p className="mb-0 text-black fw-bold">
                                    {localStorage.getItem("name")}
                                </p>
                            </div>
                            <div className="col-md-3 col-6">
                                <p className="h6 text-muted font-medium-lg">نام خانوادگی</p>
                                <p className="mb-0 text-black fw-bold">
                                    {localStorage.getItem("lastName")}
                                </p>
                            </div>
                            <div className="col-md-3 col-6">
                                <p className="h6 text-muted font-medium-lg">شماره موبایل</p>
                                <p className="mb-0 text-black fw-bold">
                                    {localStorage.getItem("cellphone")}
                                </p>
                            </div>
                            <div className="col-md-3 col-6">
                                <p className="h6 text-muted font-medium-lg">ایمیل</p>
                                <p className="mb-0 text-black fw-bold">
                                    {localStorage.getItem("email")}
                                </p>
                            </div>
                            <div className="col-md-3 col-6">
                                <p className="h6 text-muted font-medium-lg">کدملی</p>
                                <p className="mb-0 text-black fw-bold">
                                    {localStorage.getItem("nationalCode")}
                                </p>
                            </div>
                            <div className="col-md-3 col-6">
                                <p className="h6 text-muted font-medium-lg">جنسیت</p>
                                <p className="mb-0 text-black fw-bold">
                                    {localStorage.getItem("gender")}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card card-body shadow border-1 rounded rounded-4 mt-4">
                <div className="rounded box-site rounded-4 d-flex justify-content-between align-items-center py-3 mb-0">
                    <span>آخرین سفارش ها</span>
                    <Link to={'/user/orders'} className="d-flex align-items-center text-decoration-none text-black">
                        مشاهده همه
                    </Link>
                </div>
                <div className="table-responsive mt-4">
                    <table className="table font-medium table-borderless font-small text-center font-medium align-middle">
                        <thead>
                            <tr>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>ردیف</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>محصولات</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>شماره سفارش</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>مبلغ قابل پرداخت</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>وضعیت پرداخت</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders?.orders.map((order: any, index: number) => (
                                <tr key={index + 'order'}>
                                    <td>
                                        {index + 1}
                                    </td>
                                    <td>
                                        {order?.items?.map((item: any) => (
                                            <p className="text-start">
                                                {item.quantity}
                                                عدد
                                                {item.product.name}
                                            </p>
                                        ))}
                                    </td>
                                    <td>
                                        {1000 + index * 13}
                                    </td>
                                    <td>
                                        {splitNumber(order.total_amount)}
                                    </td>
                                    <td>
                                        {order.status}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default Profile;
